import React from 'react';
import {
    ListButton,
    ShowButton,
    EditButton,
    SimpleShowLayout,
    TextField,
    SimpleForm,
} from 'admin-on-rest';
import Show from '../admin/Show';
import Edit from '../admin/Edit';
import InventoryContentsTable from '../components/InventoryContentsTable';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import {CardActions} from 'material-ui/Card';
import Icon from 'material-ui/svg-icons/action/assignment-return';
import {RefreshButton} from 'admin-on-rest/lib/mui/button';

export const fuseRepackIcon = Icon;

const MakeInventoryContentsTable = ({record, view}) => {
    const collection = (record.contents) ? record.contents : [];
    return (
        <InventoryContentsTable key="inventory-contents-table" {...record} viewType={view} collection={collection}/>
    )
};

/*
 * View: Show
 */

// Set title for Show Repack or Retail Box
const ShowTitle = ({record}) => {
    return (
        <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>
            {record ? `Repack / Retail Box ${record.inv_collection_model.collection_id}` : 'Repack or Retail Box'}
        </span>
    );
};

const ShowDescription = ({record}) => {
    return (
        <span>
            <p>Review details for Repack / Retail Box and collection contents below.</p>
        </span>
    );
};

// Replace Actions for Show Repack / Retail Box
const ShowActions = ({basePath, data, canEdit}) => (
    <CardActions style={viewStyles.actions}>
        <ListButton basePath="/InventoryRepacksRetailBoxes"/>
        {data && canEdit &&
            <EditButton basePath={basePath} record={data}/>
        }
        <RefreshButton/>
    </CardActions>
);

/*
 * Show Repack / Retail Box Table
 */
export const fuseRepackRetailBoxShow = ({canEdit, ...props}) => (
    <Show {...props} title={<ShowTitle/>} desc={<ShowDescription/>}
          actions={<ShowActions canEdit={canEdit}/>}>
        <SimpleShowLayout {...props}>
            <TextField source="collection_id" label="Collection ID"/>
            <TextField source="collection_type" label="Type"/>
            <TextField source="created_by_client.location" label="Created by Location"/>
            <TextField source="modified_tz" label="Date Created"/>
            <hr style={viewStyles.break}/>
            {<MakeInventoryContentsTable view="show"/>}
        </SimpleShowLayout>
    </Show>
);

/*
 * View: Edit form
 */

// Set title for Edit Repack / Retail Box
const EditTitle = ({record}) => {
    let type = 'Repack/Retail Box';
    if (record && record.type && record.type === 'repack') {
        type = 'Repack';
    }
    if (record && record.type && record.type === 'retail_box') {
        type = 'Retail Box';
    }
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>Edit {type} {record ? `${record.barcode}` : ''}</span>;
};

const EditDescription = () => {
    return (
        <span>
            <p>Edit quantities of the items in the Collection, remove items from the Collections, or add new Product
                Units to the Collection. Click <strong>Save</strong> to update.</p>
        </span>
    );
};

// Replace Actions for Edit Repack / Retail Box
const EditActions = ({basePath, data}) => (
    <CardActions style={viewStyles.actions}>
        <ListButton basePath="/InventoryRepacksRetailBoxes"/>
        <ShowButton basePath={basePath} record={data}/>
        <RefreshButton/>
    </CardActions>
);

/*
 * Edit Repack / Retail Box form
 */
export const fuseRepackRetailBoxEdit = (props) => (
    <Edit {...props} title={<EditTitle/>} desc={<EditDescription/>} actions={<EditActions/>}>
        <SimpleForm>
            <TextField source="collection_id" label="Collection ID"/>
            <TextField source="collection_type" label="Type"/>
            <TextField source="created_by_client.location" label="Created by Location"/>
            <TextField source="modified_tz" label="Date Created"/>
            <hr style={viewStyles.break}/>
            {<MakeInventoryContentsTable view="edit"/>}
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/repackRetailBox.js